import vkBridge from "@vkontakte/vk-bridge";
import {syncPlayerProfile} from "../services/player";

// syncPlayerProfileIfNeeded сравнивает данные VK и бэка и запускает синхронизацию при расхождении
export const syncPlayerProfileIfNeeded = (player) => {
    if (!player) {
        return Promise.resolve();
    }

    if (!vkBridge.supports('VKWebAppGetUserInfo')) {
        return Promise.resolve();
    }

    return vkBridge.send('VKWebAppGetUserInfo').then(userInfo => {
        if (!userInfo) {
            return Promise.resolve();
        }

        const vkName = [userInfo.first_name, userInfo.last_name].filter(Boolean).join(' ').trim();
        const vkAvatar = userInfo.photo_200 || userInfo.photo_100 || userInfo.photo || '';
        const currentName = (player.name || '').trim();
        const currentAvatar = player.avatar || '';
        const shouldSync = (vkName && vkName !== currentName) || (vkAvatar && vkAvatar !== currentAvatar);

        if (!shouldSync) {
            return Promise.resolve();
        }

        return syncPlayerProfile();
    }).catch(err => {
        console.log("Не удалось синхронизировать профиль пользователя:", err);
    });
};
